import { createContext } from "react";
import { AppData, defaultAppData } from "../Models/AppData";
 
export const AppDataContext = createContext<AppData>(defaultAppData) 